import { useState } from 'react';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import StylishNewInput from 'components/DesignSystems/New/StylishNewInput';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

type AddResourceHeaderProps = {
  onAdd: (name: string) => void;
  disabled?: boolean;
};

const AddResourceHeader: React.FC<AddResourceHeaderProps> = ({
  onAdd,
  disabled = false,
}) => {
  const [showInput, setShowInput] = useState(false);
  const [name, setName] = useState('');

  const reset = () => {
    setShowInput(false);
    setName('');
  };

  const handleAdd = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onAdd(trimmed);
    reset();
  };

  if (!showInput) {
    return (
      <StylishNewButton
        onClick={() => setShowInput(true)}
        disabled={disabled}
        className="button--secondary button--sml"
      >
        <SharedIcon iconName="add" classes="me-1" size="sm" />
        Add Resource
      </StylishNewButton>
    );
  }

  return (
    <div className="d-flex flex-column gap-1">
      <StylishNewInput
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Resource name"
        maxLength={100}
      />
      <div className="d-flex gap-1">
        <StylishNewButton
          onClick={handleAdd}
          disabled={!name.trim()}
          className="button--sml"
        >
          Add
        </StylishNewButton>
        <StylishNewButton
          className="button--secondary button--sml"
          onClick={reset}
        >
          Cancel
        </StylishNewButton>
      </div>
    </div>
  );
};

export default AddResourceHeader;
